module.exports = __webpack_public_path__ + "img/DAVID_CANNON_04-rs.1fc25fc7.jpg";